import { AlertCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { CardGrid, ModuleCard, Page } from '@rammetec/design-system'
import { useAvailableInstances, useAvailableModules, useSessionContext } from '@vectorhub/application'
import { resolveIcon } from '@/app/modules/Icon'

function NoModulesState() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-10 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <AlertCircle className="h-8 w-8" />
      </div>
      <div className="space-y-1">
        <div className="text-base font-semibold text-foreground">
          Sem módulos VectorHub liberados
        </div>
        <div className="text-sm text-muted-foreground">
          Contate o administrador da sua organização para liberar o acesso.
        </div>
      </div>
    </div>
  )
}

export function WorkspacePage() {
  const navigate = useNavigate()
  const { isLoading } = useSessionContext()
  const modules = useAvailableModules()
  const instances = useAvailableInstances()

  const moduleBySlug = new Map(modules.map((m) => [m.slug, m]))

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center p-10 text-sm text-muted-foreground">
        Carregando módulos…
      </div>
    )
  }

  if (instances.length === 0) {
    return <NoModulesState />
  }

  return (
    <Page
      name="vectorhub.workspace"
      title="VectorHub"
      description="Selecione um módulo para começar."
      productArea="vectorhub"
    >
      <CardGrid columns={{ sm: 2, lg: 3 }}>
        {instances.map((instance) => {
          const module = moduleBySlug.get(instance.slug)
          if (!module) return null
          const title = instance.label ?? module.label
          return (
            <ModuleCard
              key={instance.id}
              icon={resolveIcon(module.icon)}
              title={title}
              description={module.description}
              aria-label={`Abrir ${title}`}
              onClick={() => navigate(`/m/${instance.slug}`)}
            />
          )
        })}
      </CardGrid>
    </Page>
  )
}
